import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private loadingSubject = new BehaviorSubject<number>(0);
  private activeRequests = 0;
  loading$ = this.loadingSubject.asObservable();

  show() {
    this.activeRequests += 1;
    this.loadingSubject.next(this.activeRequests);
  }

  hide() {
    this.activeRequests = Math.max(this.activeRequests - 1, 0);
    this.loadingSubject.next(this.activeRequests);
  }

  cancel() {
    this.activeRequests = 0;
    this.loadingSubject.next(0);
  }
}
